import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { AppStore } from "../redux/store";
import { PrivateRoutes, Roles, Profiles } from '../models';

interface Props {
	allowedRoles?: Roles[];
	allowedProfiles?: Profiles[];
}

const RoleGuard = ({ allowedRoles, allowedProfiles }: Props) => {
	const userState = useSelector((store: AppStore) => store.user);

	const hasAllowedRole = allowedRoles ? allowedRoles.some(role => userState?.role?.includes(role)) : false;
	const hasAllowedProfile = allowedProfiles ? allowedProfiles.some(profile => userState?.profiles?.includes(profile)) : false;

	if (hasAllowedRole || hasAllowedProfile) {
		return <Outlet />;
	} else {
		return <Navigate replace to={PrivateRoutes.DASHBOARD} />;
	}
}

export default RoleGuard;
